import getCombatantLastRoundAction from './getCombatantLastRoundAction'

function countUnusedReactions(combatant, maxCR) {
  let unusedReactionCount = 0

  for (let reactionNum = 1; reactionNum <= maxCR; reactionNum++) {
    if (combatant[`cr_name${reactionNum}`] === 'pending') {
      unusedReactionCount++
    }
  }

  return unusedReactionCount
}

export default function getCombatantExtraAttackInvalidReason({
  combatant,
  maxCA,
  maxCR,
  nextAction = null,
  onCounters = false,
}) {
  if (countUnusedReactions(combatant, maxCR) < 1) {
    return 'No unused reactions'
  }

  if (!combatant?.shield && !combatant?.second_weapon) {
    return 'No Shield/\nSecond Weapon'
  }

  if (nextAction) {
    return 'Action in progress'
  }

  if (onCounters) {
    return 'On counters'
  }

  const lastAction = getCombatantLastRoundAction(combatant, maxCA)

  if (!lastAction.action?.eligible_extra_attack_last_action) {
    return 'Ineligible last action'
  }

  return ''
}
